import { Fetcher, buildProviders, targets } from "@movie-web/providers";

import { isExtensionActiveCached } from "@/backend/extension/messaging";
import {
  makeExtensionFetcher,
  makeLoadBalancedSimpleProxyFetcher,
  makeStandardFetcherWithNativeAbortSignal,
} from "@/backend/providers/fetchers";
import { vidSrcSource } from "@/backend/providers/vidsrc";

function makeProvidersWithVidSrc(ops: {
  fetcher: Fetcher;
  proxiedFetcher?: Fetcher;
  target: (typeof targets)[keyof typeof targets];
  consistentIpForRequests?: boolean;
}) {
  let builder = buildProviders()
    .setTarget(ops.target)
    .setFetcher(ops.fetcher)
    .addBuiltinProviders()
    .addSource(vidSrcSource);

  if (ops.proxiedFetcher)
    builder = builder.setProxiedFetcher(ops.proxiedFetcher);
  if (ops.consistentIpForRequests)
    builder = builder.enableConsistentIpForRequests();

  return builder.build();
}

export function getProviders() {
  if (isExtensionActiveCached()) {
    return makeProvidersWithVidSrc({
      fetcher: makeExtensionFetcher(),
      target: targets.BROWSER_EXTENSION,
      consistentIpForRequests: true,
    });
  }

  return makeProvidersWithVidSrc({
    fetcher: makeStandardFetcherWithNativeAbortSignal(),
    proxiedFetcher: makeLoadBalancedSimpleProxyFetcher(),
    target: targets.BROWSER,
  });
}
